import React, { useState } from "react";

import { useLocation } from "react-router-dom";

import dashboardBanner from "../../assets/hero-pc-new.jpg";

import Header from "./header.component";
import Sidebar from "./sidebar.component";

export default function Dashboard(props) {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarType={props?.sidebarType}
      />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}

        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main>
          <div
            className={`${
              !location?.pathname.includes("/auth/dashboard") && "py-8"
            } px-4 sm:px-6 lg:px-8 w-full max-w-9xl mx-auto`}
          >
            {props?.children}
          </div>

          {location?.pathname.includes("/auth/dashboard") ? (
            <article className="relative">
              <div>
                <img
                  src={dashboardBanner}
                  className="w-full object-cover"
                  alt="Gratitude Dashboard Banner"
                />
              </div>

              <div className="absolute inset-0 bg-black opacity-70">
                <div className="text-white flex flex-col h-[70vh] items-center justify-center text-5xl font-light font-yantramanav">
                  Welcome Admin
                </div>
              </div>
            </article>
          ) : null}
        </main>
      </div>
    </div>
  );
}
